import { EventAssociatedModel, EventAssessment } from '~/types/adamTypes';

export type UseAppEventAssessmentRun = {
  opened: (disciplineId: string, chapterIds: string[]) => Promise<void>;
};

export const useAppEventAssessmentRun = (): UseAppEventAssessmentRun => {
  const { createEvent } = useAppEvent(EventAssociatedModel.Assessment);

  const { mainContent } = useContents();

  const getEventData = () => {
    const eventData: any = {};

    return eventData;
  };

  const opened = async (disciplineId: string, chapterIds: string[]) => {
    const eventData = getEventData();
    eventData.libraryBookId = mainContent.value.id;
    eventData.Discipline = toRaw(disciplineId);
    eventData.ChapterIds = toRaw(chapterIds);
    await createEvent(EventAssessment.Opened, eventData);
  };

  return {
    opened,
  };
};
